var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructionHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 92",
    style: {
      enableBackground: "new 0 0 92 92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B9B9B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,0C20,0.3-0.3,21.2,0,46.6C0.3,72,21.2,92.3,46.6,92C72,91.7,92.3,70.8,92,45.4C91.7,20,70.8-0.3,45.4,0z  M45.2,74L45,74c-3.9-0.1-6.7-3-6.6-6.9c0.1-3.8,2.9-6.5,6.7-6.5l0.2,0c4,0.1,6.7,3,6.6,6.9C51.9,71.3,49.1,74,45.2,74z M61.7,41.3 c-0.9,1.3-2.9,2.9-5.5,4.9l-2.8,1.9c-1.5,1.2-2.5,2.3-2.8,3.4c-0.3,0.9-0.4,1.1-0.4,2.9l0,0.5H39.4l0-0.9c0.1-3.7,0.2-5.9,1.8-7.7 c2.4-2.8,7.8-6.3,8-6.4c0.8-0.6,1.4-1.2,1.9-1.9c1.1-1.6,1.6-2.8,1.6-4c0-1.7-0.5-3.2-1.5-4.6c-0.9-1.3-2.7-2-5.3-2 c-2.6,0-4.3,0.8-5.4,2.5c-1.1,1.7-1.6,3.5-1.6,5.3v0.5H27.9l0-0.5c0.3-6.8,2.7-11.6,7.2-14.5c2.8-1.8,6.3-2.7,10.4-2.7 c5.3,0,9.9,1.3,13.4,3.9c3.6,2.6,5.4,6.5,5.4,11.6C64.4,36.3,63.5,38.9,61.7,41.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionHelp);
export default __webpack_public_path__ + "static/media/instruction-help.7c179d4ce506669d20c03dd510126705.svg";
export { ForwardRef as ReactComponent };